import { useMutation, useQuery, useQueryClient } from "react-query";
import { CreateOutfitter, Outfitter } from "../models/Outfitter";
import { useBackendMutationFunction } from "./common/useBackendMutationFunction";
import { useBackendQueryFunction } from "./common/useBackendQueryFunction";
import { UrlQuery } from "./common/useBackendUrl";

export const GetOutfittersKey = "GetOutfitters";

interface UseGetOutfitterProps extends UrlQuery {
  id: string;
}

export function useGetOutfitter(props: UseGetOutfitterProps) {
  const queryFn = useBackendQueryFunction<Outfitter>("/outfitters/:id", props);

  return useQuery<Outfitter>([GetOutfittersKey, props], queryFn);
}

export function useGetOutfitters() {
  const queryFn = useBackendQueryFunction<Outfitter[]>("/outfitters");

  return useQuery<Outfitter[]>([GetOutfittersKey], queryFn);
}

interface UseDeleteOutfitterProps extends UrlQuery {
  outfitterId: string;
}
export function useDeleteOutfitter(props: UseDeleteOutfitterProps) {
  const mutationFn = useBackendMutationFunction<Outfitter, void>(
    "/outfitters/:outfitterId",
    "DELETE",
    props
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetOutfittersKey);
    },
  });
}

export function usePostOutfitter() {
  const mutationFn = useBackendMutationFunction<Outfitter, CreateOutfitter>(
    "/outfitters",
    "POST"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetOutfittersKey);
    },
  });
}

export function usePatchOutfitter() {
  const mutationFn = useBackendMutationFunction<Outfitter, Outfitter>(
    "/outfitters",
    "PATCH"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetOutfittersKey);
    },
  });
}
